import React, { useState, useEffect } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Button,
} from "devextreme-react/data-grid";
import Button1 from "@material-ui/core/Button";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Guid from "devextreme/core/guid";
import Select from "react-select";
import { useNavigate } from "react-router";
import axios from "axios";
import { api_path } from "../shared";
export function AgentContactDataGrid(props) {
  const classes = useStyles();
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_ID);
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [getYear, setYear] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [selectYear, setSelectYear] = useState([]);
  const [getMonth, setMonth] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [selectMonth, setSelectMonth] = useState([]);
  const [getShipper, setShipper] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  const [selectShipper, setSelectShipper] = useState([]);
  const [getCommodity, setCommodity] = useState([]);
  const [commodityList, setCommodityList] = useState([]);
  const [selectCommodity, setSelectCommodity] = useState([]);
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [getTotalCount, setTotalCount] = useState(0);

  const [getStatus, setStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);

  const [getResult, setResult] = useState("");
  const [getErrMsg, setErrMsg] = useState("");
  const pageSizes = [25, 50, 100];
  const [selectedValue, setSelectedValue] = useState("option1");
  const [getDateStr, setDateStr] = useState(
    "Please click Search button to refresh data."
  );
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const [showSelect, setShowSelect] = useState(false);
  const navigate = useNavigate();
  const url =
    api_path +
    "/MS_AGENT_LIST.php"
const dataSource = createStore({
  key: "AgentID",
  loadUrl: `${url}`,
});
  
  useEffect(() => {
    console.log("user role... "+getUserRole)
    if(getUserRole==1){
      setButtonDisabled(true);
      setSelectSale(getUserID)
      setSale({
        EmpEmail: getUserID,
        EmpEmail: getUserID,
      });
    }else if(getUserRole==2){
      setButtonDisabled(true);
      fetchSale();
    }else if(getUserRole==4){
      setButtonDisabled(false);
      fetchSale();
      setUserID("")
    }else if(getUserRole==7){
      setButtonDisabled(true);
      fetchSale();
      setUserID("")
    }
}, []);
  const fetchSale = () => {
    axios
      .get(api_path + `/sales.php`)
      .then((response) => {
        setSaleList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchSaleByUSERID = () => {
    axios
      .get(api_path + `/INQUIRY_GETSALES.php?roleid=`+getUserRole+`userid=`+getUserID)
      .then((response) => {
        setSaleList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSaleChange = (obj) => {
    setSelectSale(obj.EmpEmail);
    setSale({ EmpEmail: obj.EmpEmail, EmpEmail: obj.EmpEmail });
  };

  function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString("default", { day: "2-digit" });
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.toLocaleString("default", { year: "numeric" });
    return day + "-" + month + "-" + year;
  }
  const handleSearch = (e) => {
    console.log("Select sale... " + selectSale)
    console.log("Select status... " + selectStatus)
  
  };
  const handleClearInputClick = () => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSale([]);
    setSelectSale([]);
    setStatus([]);
    setSelectStatus([]);
    setDateFrom(formattedfirstDay);
    setDateTo(formattedlastDay);
    setResult("");
    setDateStr("");
    setTotalCount(0);
  };
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
  };
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const handleAddButtonClick = React.useCallback((e) => {
    navigate({
      pathname: "/s-crm/SaleInquiryForm",
      search: ""
    });
  }, []);
  const onCopyButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    navigate({
      pathname: "/s-crm/SaleInquiryForm",
      search: "?param1=" + e.row.key,
    });
  }, []);
  const onEditButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    const result = dataRow.DESTINATION_COUNTRY;
    navigate({
      pathname: "/s-crm/SaleInquiryDetail",
      search: "?param1=" + e.row.key,
    });
  }, []);
  const onRatingButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    const result = dataRow.DESTINATION_COUNTRY;
    navigate({
      //pathname: "/s-crm/SaleInquiryFormRating",
      pathname: "/s-crm/SaleInquiryDetail",
      search: "?param1=" + e.row.key,
    });
  }, []);
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      // if (
      //   e.column.dataField === "COMPLETE_DATE" &&
      //   e.data.STATUS_ID == 5 //Complete
      // ) {
      //   e.cellElement.style.cssText = "color: #FFF; background-color: #FB6A00; text-align:center;";
      //   e.cellElement.value=null;
      // }
      if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 1 //new
      ) {
        e.cellElement.style.cssText = "color: #FFF; background-color: #FB6A00; text-align:center;";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 2 //Processing
      ) {
        e.cellElement.style.cssText = "color: #FFF; background-color: #0078d4; text-align:center;";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 3 //Done
      ) {
        e.cellElement.style.cssText = "color: #FFF; background-color: #A5BF00; text-align:center;";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 4 //Reject
      ) {
        e.cellElement.style.cssText = "color: #FFF; background-color: red; text-align:center;";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 5 //Complete
      ) {
        e.cellElement.style.cssText = "color: #FFF; background-color: #119f4a; text-align:center;";
      }
    }
  };

  const  customizeText = (cellInfo) => {
      if (
        cellInfo.value === "1900-01-01 00:00:00.000" ||
        cellInfo.value === "" ||
        cellInfo.value === null ||
        cellInfo.value === undefined
      ) {
        return "-";
      } else {
        return cellInfo.valueText
      }
  }
  const isComplete = (status) =>
    status && ["3"].indexOf(status.trim().toUpperCase()) >= 0;
  const isRatingIconVisible = (e) => isComplete(e.row.data.STATUS_ID);

  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "SaleInquiry.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const options = [
    { value: "1", label: "New" },
    { value: "2", label: "Processing" },
    { value: "3", label: "Done" },
    { value: "4", label: "Reject" },
    { value: "5", label: "Complete" },
  ];
  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">Agent Contact</label>
      </Grid>

      <Grid container className={classes.root}>
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          showScrollbar={true}
          keyExpr="AgentID"
          onExporting={onExporting}
          
        >
           <Scrolling rowRenderingMode="virtual" showScrollbar="always" useNative="false" scrollByThumb="true"></Scrolling>
          {/* <MasterDetail enabled={true} component={InquiryMasterDetailView} /> */}
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <Selection mode="multiple" />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
 <Column dataField="AgentID" width={50} visible={false}/>
         
     
          <Column
            dataField="AgentCode"
            caption="Agent Code"
            width={50}
          />
          <Column
            dataField="AgentName"
            caption="AgentName"
            allowHiding={false}
          />
          <Column
            dataField="Country"
            caption="Country"
            allowHiding={false}
          />
          <Column dataField="ContactName" caption="ContactName" allowHiding={false} />
          <Column dataField="TitleName" caption="TitleName" allowHiding={false} />
          <Column
            dataField="Email"
            caption="Email"
            allowHiding={false}
          />
          <Column
            dataField="BasedOffice"
            caption="BasedOffice"
            allowHiding={false}
          />
           <Column
            dataField="Branch"
            caption="Branch"
            allowHiding={false}
            width={200}
          />
          <Column dataField="PIC"/>
          <Column
            dataField="Network"
          />
         
          <LoadPanel enabled={true} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          
        </DataGrid>
      </Grid>
    </Container>
  );
}
